/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesArenaGameStatusSchema = z.enum([
  "Pending",
  "Live",
  "Completed",
  "Cancelled",
]);
